import React, { useEffect, useState } from "react";
import EditModal from "@core/modals/EditModal";
import EditButton from "@core/buttons/atoms/EditButton";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import MinorStrataService from "@services/MinorStrataService";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import SubStrataSelect from "@components/SubStrata/partials/SubStrataSelect";

const EditMinorStrata = ({ minorStrata, onEdited }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [englishName, setEnglishName] = useState("");
  const [description, setDescription] = useState("");
  const [subStratumId, setSubStratumId] = useState("");
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setEnglishName("");
    setDescription("");
    setSubStratumId("");
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    MinorStrataService.update(
      minorStrata.id,
      name,
      englishName,
      subStratumId,
      description
    )
      .then(() => {
        showSuccess(t("minorStrataEditedSuccessfully"));
        onEdited();
        closeModal();
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (showModal)
      MinorStrataService.find(minorStrata.id).then((response) => {
        setName(response.data.data.name);
        setEnglishName(response.data.data.name_eng);
        setDescription(response.data.data.description);
        setSubStratumId(response.data.data.sub_stratum_id);
      });
  }, [minorStrata.id, showModal]);

  return (
    <PermissionHandler permission={"update_minor_stratum"}>
      <EditButton onClick={() => setShowModal(true)} />
      <EditModal
        show={showModal}
        title={t("editMinorStratum")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
        label={t("edit")}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5">
          <Input
            label={t("name")}
            placeholder={t("name")}
            value={name}
            onChange={setName}
            height="h-10"
          />
          <Input
            height="h-10"
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={englishName}
            onChange={setEnglishName}
          />
          <Input
            height="h-10"
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
          />
          <div>
            <div className="text-sm font-semibold mb-2">
              {t("chooseSubStratum")}
            </div>
            <SubStrataSelect
              openModal={showModal}
              onSelect={setSubStratumId}
              selected={subStratumId}
            />
          </div>
        </div>
      </EditModal>
    </PermissionHandler>
  );
};

export default EditMinorStrata;
